import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "ui";
import { useAppSelector } from "store";
import { useMerchant } from "../../../account/api/merchant";
import { Header } from "./header";
import { useSidebarItem } from "../hooks/sidebarItem";

import styles from "./dashboard-layout.module.scss";
export const DashboardLayout = () => {
  const [showSidebar, setShowSidebar] = useState(
    window.innerWidth > 670 ? true : false
  );
  const { sidebarItems } = useSidebarItem();

  const location = useLocation();

  const userId = useAppSelector((state) => state.dashboard.userId);
  const { data } = useMerchant({
    id: userId,
  });
  const user = data?.data;
  useEffect(() => {
    if (window.innerWidth < 670) setShowSidebar(false);
  }, [location.pathname]);

  return (
    <div className={styles.dashboard_layout_container}>
      <div
        className={showSidebar ? styles.sidebar_shadow : ""}
        onClick={() => {
          setShowSidebar(false);
        }}
      ></div>
      <div className={showSidebar ? styles.sidebar : styles.translate_sidebar}>
        <Sidebar
          items={sidebarItems}
          full_name={
            (user && user.firstNameFa + " " + user.lastNameFa) || "نامشخص"
          }
        />
      </div>

      <div
        className={showSidebar ? styles.main_content : styles.main_content_full}
      >
        <Header
          showSidebar={false}
          SidebarButtonHandler={() => {
            setShowSidebar(!showSidebar);
          }}
        />
        <div className={styles.outlet}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};
